/* =============================================================
   BLUEMINGS PRE-LAUNCH — Page-scoped JS
   - Nav scroll-blur effect
   - Newsletter session-state handling
   ============================================================= */

(function () {
  'use strict';

  document.documentElement.classList.add('js-loaded');

  // ============================================================
  // NAV SCROLL-TRIGGERED BLUR
  // Adds .is-scrolled to .bm-nav when user scrolls past 40px.
  // ============================================================
  var nav = document.querySelector('.bm-nav');
  if (nav) {
    var onScroll = function () {
      if (window.scrollY > 40) {
        nav.classList.add('is-scrolled');
      } else {
        nav.classList.remove('is-scrolled');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ============================================================
  // NEWSLETTER FORM — SHOPIFY-CONFIRMED SESSION STATE
  // The form submits natively to Shopify. Only Shopify's server-rendered
  // posted_successfully state is persisted for the current browser-tab session.
  // ============================================================
  var newsletterStorageKey = 'bluemings_newsletter_subscribed';
  var forms = document.querySelectorAll('form[data-bm-newsletter]');

  function readSubscribedSession() {
    try {
      return window.sessionStorage.getItem(newsletterStorageKey) === 'true';
    } catch (error) {
      return false;
    }
  }

  function writeSubscribedSession() {
    try {
      window.sessionStorage.setItem(newsletterStorageKey, 'true');
    } catch (error) {
      // The Shopify-confirmed success remains visible even if storage is blocked.
    }
  }

  function showConfirmedSuccess(form) {
    var formRow = form.querySelector('[data-bm-form-row]');
    var microcopy = form.querySelector('[data-bm-form-microcopy]');
    var successEl = form.querySelector('[data-bm-form-success]');
    var errorEl = form.querySelector('[data-bm-form-error]');

    if (formRow) formRow.hidden = true;
    if (microcopy) microcopy.hidden = true;
    if (successEl) successEl.hidden = false;
    if (errorEl) errorEl.hidden = true;
  }

  var shopifyConfirmed = Array.prototype.some.call(forms, function (form) {
    var successEl = form.querySelector('[data-bm-form-confirmed="true"]');
    return Boolean(successEl);
  });

  if (shopifyConfirmed) {
    writeSubscribedSession();
  }

  if (shopifyConfirmed || readSubscribedSession()) {
    forms.forEach(showConfirmedSuccess);
  } else {
    forms.forEach(function (form) {
      form.addEventListener('submit', function () {
        var submitBtn = form.querySelector('button[type="submit"]');

        // Do not set session state here: Shopify has not confirmed success yet.
        // Native browser validation runs first; valid forms then post to Shopify.
        if (submitBtn && form.checkValidity()) {
          submitBtn.disabled = true;
          submitBtn.style.opacity = '0.5';
        }
      });
    });
  }

  // ============================================================
  // FADE-IN ON SCROLL — DISABLED (per user request)
  // ============================================================
  /*
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.bm-prelaunch section').forEach(function (s) {
      s.classList.add('bm-reveal');
      observer.observe(s);
    });
  }
  */
})();
